<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/denuncias">Denúncias</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes da Denúncia</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Denúncia
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Protocolo</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="denuncia.protocolo"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Nome do Denunciante</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="denuncia.nome_denunciante"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Unidade</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="denuncia.nome_unidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Tipo de Denúncia</label>
                <v-select
                  :disabled="true"
                  label="tipo"
                  v-model="denuncia.tipo_denuncia"
                  class="form-select"
                  :reduce="tipos_denuncia => tipos_denuncia.id"
                  :options="tipos_denuncia"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Data da Denúncia</label>
                <date-picker 
                  v-model="denuncia.created_at"
                  :lang="lang"
                  :disabled="true"
                  format="DD/MM/YYYY HH:mm"
                  type="datetime"
                ></date-picker>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Empresa</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="denuncia.nome_empresa"
                />
              </div>
            </div>
            
          </div>

          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label>Descrição</label>
                <textarea
                  readonly
                  rows="4"
                  class="form-control"
                  v-model="denuncia.descricao"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Status Atual</label>
                <v-select
                  label="status"
                  v-model="denuncia.status_atual"
                  class="form-select"
                  :reduce="status => status.id"
                  :options="status"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p class="pull-right">
                <button href="#0" class="btn_1 medium" @click="editaInformacoes">Salvar</button>
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Eventos</label>
                <v-expansion-panel>
                  <v-expansion-panel-content
                    v-for="item in eventos"
                    :key="item.id"
                  >
                    <template v-slot:header>
                      <div class="eventTitle">{{ padronizaDataHora(item.created_at) }}</div>
                      <div class="eventTitle">{{ item.titulo }}</div>
                    </template>
                    <v-card>
                      <v-img v-if="item.arquivo_evento_denuncia"
                        :src=baseUrl+item.arquivo_evento_denuncia
                      ></v-img>
                      <v-card-text class="ml-2">{{item.descricao}}</v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </div>
            </div>           
          </div>
         
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'
import DatePicker from 'vue2-datepicker';

export default {
  components: {DatePicker},
  mixins: [funcoesGerais],
  data() {
    return {
      id_denuncia: this.$route.params.id_denuncia,
      isLoading: false,
      isExpanded: false,
      denuncia: {},
      eventos: [],
      baseUrl: '',
      tipos_denuncia: [
        { tipo:'Assédio Moral', id: 1},
        { tipo:'Assédio Sexual', id: 2},
        { tipo:'Descumprimento de Normas', id: 3},
        { tipo:'Fraude/Corrupção/Suborno', id: 4},
        { tipo:'Outros', id: 5}
      ],
      status: [
        { status:'Recebida', id: 1},
        { status:'Em Análise', id: 2},
        { status:'Finalizada', id: 3},
        { status:'Procedente', id: 4},
        { status:'Improcedente', id: 5},
        { status:'Inconclusiva', id: 6}
      ]
    };
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      self.isLoading = true;
      axios.get(`denuncias/${this.id_denuncia}`)
        .then((res) => {
          this.isLoading = false
          this.denuncia = res.data
          this.eventos = res.data.eventos_denuncias
          this.baseUrl = axios.defaults.baseURL.slice(0, -3) + 'arquivos_eventos_denuncia/'
          let temp = res.data.data_denuncia
          this.denuncia.data_denuncia = this.padronizaDataHora(temp)

        }, err => {
          this.isLoading = false;
          tratamento_requisicao(err);
        })
    },
    editaInformacoes() {
      let self = this;
      self.isLoading = true;

      let objRequest = new FormData();

      objRequest.append('status_atual', self.denuncia.status_atual);
      
      ajax("post", "denuncias/" + self.denuncia.id, objRequest)
        .then(() => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Informações foram atualizadas com sucesso!"
          );
          this.fetchData();
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error);
        });
		},
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style>
  .eventTitle {
      font-weight: bold;
      font-size: 14px !important;
    }
</style>